export const isConnectSuccessVerified = _ref => {
  var _userDomain$domain;
  let {
    siteId,
    userDomain
  } = _ref;
  return Boolean(siteId) && !(userDomain != null && userDomain.error) && (userDomain == null || (_userDomain$domain = userDomain.domain) == null ? void 0 : _userDomain$domain.siteId) === siteId;
};
//# sourceMappingURL=connectSuccessVerification.js.map